import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IGqlBaseOptions } from 'src/app/shared/modules/graphql/interfaces';
import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { IApiInvestigationMetricsClientContactConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { GqlInvestigationMetricsContactService } from 'src/app/shared/modules/graphql/services/reports/investigation-metrics/investigation-metrics-contact/investigation-metrics-contact.service';

@Injectable()
export class InvestigationMetricsContactService {
  constructor(
    private reports: GqlInvestigationMetricsContactService
  ) { }

  public get(filters?: IApiInvestigationMetricsFilter[], options?: IGqlBaseOptions): Observable<IApiInvestigationMetricsClientContactConnection> {
    return this.reports.get(filters, options || new ListPage());
  }

}
